<template>
    <div>
        <div class="d-flex align-items-center mb-3">
            <div>
                <h1 class="page-header mb-0"><i class="fa-solid fa-list-check"></i> Feladatok</h1>
            </div>
            <div class="ms-auto">
                <new-daily-task-button mode="new" :locations="locationslinear" :users="users" :partners="partners"
                    :responsible_departments="responsible_departments" :available_tasks="available_tasks" @created="loadNewDailyTaskCalendar">
                </new-daily-task-button>
            </div>
        </div>
        <panel title="Feladatok">
            <div class="row mb-2">
                <div class="col">
                    <input type="date" class="form-control" v-model="intervalStart">
                </div>
                <div class="col">
                    <input type="date" class="form-control" v-model="intervalEnd">
                </div>
                <div class="col">
                    <button class="btn btn-primary mx-1" @click="setDateInterval('today')">mai</button>
                    <button class="btn btn-primary mx-1" @click="setDateInterval('tomorrow')">holnapi</button>
                    <button class="btn btn-primary mx-1" @click="setDateInterval('week')">heti</button>
                    <button class="btn btn-primary mx-1" @click="setDateInterval('custom')">egyéni</button>
                    <button class="btn btn-primary mx-1" @click="setDateInterval('reset')">szűrők törlése</button><br><br>
                    <a class="btn btn-success mx-1" target="_blank" :href="api_url + '/daily-tasks/today'">mai</a>
                    <a class="btn btn-success mx-1" target="_blank" :href="api_url + '/daily-tasks/tomorrow'">holnapi</a>
                    <a class="btn btn-success mx-1" target="_blank" :href="api_url + '/daily-tasks/week'">heti</a>
                </div>
            </div>
            <div class="row text-danger" v-if="intervalStart != null && intervalEnd == null">
                <div class="col">
                    Adj meg intervallum vége dátumot is!
                </div>
            </div>
            <Loading title="Feladatok betöltése" v-if="!daily_tasks"></Loading>
            <!-- <NoRecords v-else-if="daily_tasks.length == 0" main_icon="fa fa-list-check" value="false"
                title="Nincsenek feladatok" subtitle="hozzon létre újat"></NoRecords> -->
            <div v-else-if="!reloading_table">
                
                <div style="overflow-x:scroll;">
                    <div style="width:2000px;">
                        <vue-good-table 
                            :columns="columns" 
                            :rows="daily_tasks" 
                            :fixed-header="true"
                            mode="remote"
                            :isLoading.sync="loading"
                            max-height="600px" 
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange" 
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange" 
                            :totalRows="totalRows"
                            :search-options="{ enabled: false, placeholder: 'Keresés...' }"
                            :pagination-options="paginationOptions" 
                            :row-style-class="rowStyleClassFn">
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">
                                    <button @click="deleteDailyTask(props.row.id)" class="btn btn-sm btn-danger mx-1"
                                        title="törlés"><i class="fa fa-trash"></i></button>
                                    <new-daily-task-button mode="edit" :daily-task="props.row" :locations="locationslinear"
                                        :users="users" :partners="partners"
                                        :responsible_departments="responsible_departments"
                                        :available_tasks="available_tasks" @saved="loadItems"></new-daily-task-button>
                                    
                                </span>
                                <span v-else-if="props.column.field == 'end_date'">                                    
                                    <span :class="props.row.progress < 100 && props.row.end_date < now ? 'text-danger' : ''">
                                        {{ props.row.end_date }}
                                    </span>
                                </span>
                                <span v-else-if="props.column.field == 'shifts'">
                                    <label v-for="shift in 3" :key="shift">
                                        <input type="checkbox" :value="shift" v-model="props.row.shifts" @change="updateShift(props.row)">
                                        {{ shift }}
                                    </label>
                                </span>
                                <span v-else-if="props.column.field == 'task_id'">
                                    <i class="fa fa-edit text-blue me-1" v-if="props.row.progress != 100"
                                        v-b-modal.taskIdEditModal @click="setDailyTaskForEdit(props.row)"></i>
                                    <router-link :to="'/tasks/' + props.row.task_id + '/edit'" v-if="props.row.task_id">
                                        #{{ props.row.task_id }}
                                    </router-link>
                                </span>
                                <span v-else-if="props.column.field == 'active'">                                    
                                    <button class="btn btn-sm btn-info mx-1" @click="openCalendarModal(props.row)"><i class="fa fa-calendar"></i></button>                                    
                                </span>
                                <span v-else-if="props.column.field == 'responsible_department_id'">
                                    <template v-if="props.row.progress != 100">
                                        <v-select v-if="responsible_departments"
                                            v-model="props.row.responsible_department_id"
                                            @option:selected="updateResponsibleDepartment(props.row)"
                                            :options="responsible_departments" :reduce="o => o.id" label="name"
                                            :clearable="false">
                                            <template #search="{ attributes, events }">
                                                <input class="vs__search" v-bind="attributes" v-on="events"
                                                    :placeholder="props.row.responsible_department_id == null ? 'Válassz jelleget!' : ''" />
                                            </template>
                                        </v-select>
                                        <loading mini v-else />
                                    </template>
                                    <span v-else>{{ props.row.responsible_department_name }}</span>
                                </span>
                                <span v-else-if="props.column.field == 'progress'">

                                    <div class="input-group" v-if="props.row.progress != 100">
                                        <select :ref="'numericInputRef_' + props.row.id"
                                            v-model="props.row.progress"
                                            @change="setProgress(props.row)">
                                            <option value="0">0</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="30">30</option>
                                            <option value="40">40</option>
                                            <option value="50">50</option>
                                            <option value="60">60</option>
                                            <option value="70">70</option>
                                            <option value="80">80</option>
                                            <option value="90">90</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <div v-else>kész <i class="fa fa-check-circle text-green"></i><i
                                            class="fa fa-undo text-red float-end" @click="resetProgress(props.row)"></i>
                                    </div>

                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
            </div>

            <b-modal id="taskIdEditModal" cancel-variant="default" @cancel="closeTaskIdEditModal()" @ok="updateTaskId"
                ok-title="Mentés" cancel-title="Mégse" :ok-disabled="loading">
                <template slot="modal-header">
                    <h4 class="modal-title">#{{ daily_task_to_edit?.id }} - {{ daily_task_to_edit?.name }} feladat eSafety
                        munkafolyamat módosítása</h4>
                    <a class="btn-close" @click="closeTaskIdEditModal()"></a>
                </template>
                <form @submit.prevent="updateTaskId()" v-if="daily_task_to_edit">
                    <v-select v-if="available_tasks && daily_task_to_edit != null" v-model="daily_task_to_edit.task_id"
                        :options="available_tasks" :reduce="o => o.id" label="name" :clearable="false">
                        <template #search="{ attributes, events }">
                            <input class="vs__search" v-bind="attributes" v-on="events"
                                :placeholder="daily_task_to_edit?.task_id == null ? 'Válassz munkafolyamatot!' : ''" />
                        </template>
                    </v-select>
                    <loading mini v-else />
                </form>
            </b-modal>
            <CalendarModal ref="calendarModal" :dailyTask="selectedDailyTask" @saved="loadItems"/>
            
        </panel>
    </div>
</template>
<style>
.text-disabled td {    color: #ccc !important;}
.mr-1{margin-right:0.3em;}
.vgt-table tbody tr td:nth-child(1) {white-space: nowrap;}

</style>

<script>
import Loading from '../../components/Loading';

import NewDailyTaskButton from './partials/NewDailyTaskButton.vue'
import DailyTask from '../../apis/DailyTask';
import moment from 'moment';
import Confirmation from "../../apis/Confirmation"
import User from "../../apis/User"
import debounce from 'debounce';
import Partner from '../../apis/Partner';
import CalendarModal from './partials/CalendarModal.vue';

// TODO törölni ezt a komment sort
export default {
    components: {
        Loading,  NewDailyTaskButton, CalendarModal
    },
    data() {
        return {
            selectedDailyTask: {},
            api_url: process.env.VUE_APP_BACK_URL,
            intervalStart: moment().format('YYYY-MM-DD'),
            intervalEnd: moment().format('YYYY-MM-DD'),
            reloading_table: false,
            loading: false,
            daily_tasks: null,
            daily_task_to_edit: null,
            now: moment().format('YYYY-MM-DD'),
            available_tasks: null,
            responsible_departments: false,
            users: false,
            partners: false,
            errors: [],
            allColumnsShown: true,
            totalRows: 0,
            serverParams: {
                columnFilters: {
                    start_date: moment().format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD')
                },
                sort:{
                    field: '',
                    type: ''
                },
                page: 1,
                perPage: 50
            },
            paginationOptions: {
                enabled: true,
                position: 'bottom',
                firstLabel: 'Első Lap',
                lastLabel: 'Utolsó Lap',
                nextLabel: 'következő',
                prevLabel: 'előző',
                rowsPerPageLabel: 'Sor oldalanként',
                perPage: 50,
                ofLabel: '/',
                allLabel: 'Összes',
                infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`,
            },
            columns: [
                {
                    label: '',
                    field: 'actions',
                    width: '110px',
                    sortable: false,
                },
                {
                    label: 'Készültség',
                    field: 'progress',
                    width: '100px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'összes',
                        filterDropdownItems: ['nem kész', '0', '10', '20', '30', '40', '50', '60', '70', '80', '90', 'kész'],
                        filterFn: this.progressFilter
                    },
                    hidden:false
                },
                {
                    label: 'Állapot',
                    field: 'active',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'összes',
                        filterDropdownItems: ['inaktív', 'aktív'],
                        filterFn: this.statusFilter
                    },
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Üzem',
                    field: 'location_name',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés',
                    },
                    hidden:false
                },
                {
                    label: 'Munkavégző',
                    field: 'worker_name',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés',
                    },
                    hidden:false
                },
                {
                    label: 'Megnevezés',
                    field: 'name',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés',
                    },
                    hidden:false
                },
                {
                    label: 'Felelős',
                    field: 'user_name',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés',
                    },
                    hidden:false
                },
                {
                    label: 'Létrehozta',
                    field: 'created_by',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés',
                    },
                    hidden:false
                },
                {
                    label: 'Kezdés',
                    field: 'start_date',
                    hidden:false
                },
                {
                    label: 'Tervezett befejezés',
                    field: 'end_date',
                    hidden:false
                },
                {
                    label: 'Műszak',
                    field: 'shifts',
                    width: '100px',
                    hidden:false,
                    sortable: false,
                },
                {
                    label: 'Munkavégzés jellege',
                    field: 'responsible_department_id',
                    width: '180px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'összes',
                        filterDropdownItems: JSON.parse(localStorage.getItem('constants')).responsible_departments.map(obj => ({ value: obj.id, text: obj.name })), //azért szedjük a constantsból,mert itt még false, csak későpbb kap értéket a responsible_departments
                    },
                    hidden:false
                },
                {
                    label: 'PM rendelés',
                    field: 'pm_order_number',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés',
                    },
                    hidden:false
                },
                {
                    label: 'eSafety mf. száma',
                    field: 'task_id',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés',
                    },
                    hidden:false
                },
                {
                    label: '#',
                    field: 'id',                    
                    type: 'number',
                    hidden:false
                },
            ]
        }
    },
    created() {
        Partner.index().then(response => {
            this.partners = response.data;
        });

        this.loadItems();

        DailyTask.getAvailableTasks().then(response => {
            this.available_tasks = response.data;
        });
        User.index().then(response => {
            this.users = response.data;
        });
        this.responsible_departments = JSON.parse(localStorage.getItem('constants')).responsible_departments;

/*         window.Echo.channel('dailytasks')
            .listen('DailyTaskDeleted', (e) => {
                this.daily_tasks.splice(this.daily_tasks.findIndex(d => d.id == e.id), 1)
            })
            .listen('DailyTaskCreated', (e) => {
                this.daily_tasks.unshift(e.daily_task);
            })
            .listen('DailyTaskUpdated', (e) => {
                let index = this.daily_tasks.findIndex(daily_task => daily_task.id === e.daily_task.id);

                if (index !== -1) {
                    Object.assign(this.daily_tasks[index], e.daily_task);
                    if(e.daily_task.id == this.selectedDailyTask.id){
                        this.selectedDailyTask = e.daily_task;
                    }
                }
            }); */

    },
    computed: {
        authenticated_user() {
            return this.$store.state.user;
        },
        locationslinear() {
            return this.$store.state.locationslinear;
        },
    },
    methods: {
        closeTaskIdEditModal() {
            this.$bvModal.hide('taskIdEditModal');
            this.daily_task_to_edit = null;
        },
        setDailyTaskForEdit(task) {
            this.daily_task_to_edit = JSON.parse(JSON.stringify(task))
        },
        updateResponsibleDepartment(row) {
            this.daily_task_to_edit = row;
            this.sendUpdate();
        },
        updateTaskId(bvModalEvt) {
            if (bvModalEvt) { //ok gombra van csak event
                bvModalEvt.preventDefault();
            }
            Confirmation.swalCustomConfirm('Biztos, hogy a ' + this.available_tasks.find(t => t.id == this.daily_task_to_edit.task_id).name + ' munkafolyamatot kapcsolod ehhez a feladathoz?', 'Igen hozzákapcsolom')
                .then(response => {
                    if (response.isConfirmed === true) {
                        console.log('minden ok');
                        this.sendUpdate()
                            .then(() => {
                                this.closeTaskIdEditModal();
                            })
                            .catch(error => {
                                console.error(error); // Catch any errors here
                            });
                    }
                });
        },
        setProgressDone(row) {
            this.daily_task_to_edit = row;
            this.daily_task_to_edit.progress = 100;
            this.sendUpdate();
        },
        resetProgress(row) {
            Confirmation.swalCustomConfirm('Biztos visszaállítod a készültséget 0 -ra?', 'Igen')
                .then(response => {
                    if (response.isConfirmed == true) {
                        this.daily_task_to_edit = row;
                        this.daily_task_to_edit.progress = 0;
                        this.sendUpdate();
                    }
                });

        },
        setProgress: debounce(function (row) {
            const parsedValue = parseInt(row['progress']);
            if (isNaN(parsedValue) || parsedValue < 0 || parsedValue > 100) {
                this.$refs['numericInputRef_' + row.id].focus();
            }
            else {

                this.daily_task_to_edit = row;
                this.sendUpdate();
                setTimeout(function () {
                    document.activeElement.blur();
                }, 200);

            }

        }, 200),                
        sendUpdate() {
            return DailyTask.update(this.daily_task_to_edit.id, this.daily_task_to_edit);
        },
        validateInput(row, field) {
            // csak számok
            row[field] = row[field].replace(/\D/g, '');
            if (row[field] == '100') {
                this.setProgressDone(row);
            }
        },
        deleteDailyTask(id) {
            Confirmation.swalDelete()
                .then(response => {
                    if (response.isConfirmed === true) {
                        DailyTask.delete(id).then(() => {
                            this.loadItems();
                        });
                    }
                });
        },
        updateShift(row) {
            this.daily_task_to_edit = row;
            this.sendUpdate();
        },
        statusFilter(rowValue, filterValue) {
            const boolValue = filterValue == 'aktív'
            return rowValue == boolValue;
        },
        progressFilter(rowValue, filterValue) {
            if(filterValue == 'nem kész'){
                return rowValue < 100;
            }
            else if(filterValue == 'kész'){
                return rowValue == 100;
            }
            else{
                return rowValue == parseInt(filterValue);
            }
        },
        //a határidő tartható és a műszaki tartalom változás filter esetén is ezt használjuk,mert ugyanaz a működése: ha null, akkor igen, ha nem null, akkor nem
        deadlineFilter(rowValue, filterValue) {
            if(filterValue == 'nem'){
                return rowValue == null;
            }
            else{
                return rowValue != null;
            }
        },
        rowStyleClassFn(row) {
            return row.active == 0 ? 'text-disabled' : '';
        },
        setDateInterval(interval) {
            switch (interval) {
                case 'today':
                    this.intervalStart = moment().format('YYYY-MM-DD');
                    this.intervalEnd = moment().format('YYYY-MM-DD');                    
                    break;
                case 'tomorrow':
                    this.intervalStart = moment().add(1, 'days').format('YYYY-MM-DD');
                    this.intervalEnd = moment().add(1, 'days').format('YYYY-MM-DD');
                    break;
                case 'week':
                    this.intervalStart = moment().locale('hu').startOf('week').format('YYYY-MM-DD');
                    this.intervalEnd = moment().locale('hu').endOf('week').format('YYYY-MM-DD');
                    break;
                case 'custom':
                    break;
                case 'reset':
                    this.intervalStart = null;
                    this.intervalEnd = null;
                    break;

            }
            this.serverParams.columnFilters.start_date = this.intervalStart;
            this.serverParams.columnFilters.end_date = this.intervalEnd;
            this.loadItems();
        },
        openCalendarModal(row) {
            this.selectedDailyTask = row;
            this.$refs.calendarModal.openModal();
        },
        updateParams(newProps) {
            // Merge the current serverParams with newProps
            if(newProps.columnFilters){
                newProps.columnFilters.start_date = this.intervalStart;
                newProps.columnFilters.end_date = this.intervalEnd;
            }
            
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            // Loop through the keys and remove properties with empty values
            Object.keys(this.serverParams.columnFilters).forEach(key => {
                if (
                    this.serverParams.columnFilters[key] === null || 
                    this.serverParams.columnFilters[key] === undefined || 
                    this.serverParams.columnFilters[key] === ''
                ) {
                    delete this.serverParams.columnFilters[key];
                }
            });
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage });
            this.loadItems();
        },
        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
            this.loadItems();
        },
        onColumnFilter(params) {
            this.updateParams(params);
            this.serverParams.page = 1;
            this.serverParams.currentPage = 1;
            this.loadItems();
        },
        setLoading(value) {
            this.loading = value;
        },
        loadNewDailyTaskCalendar(dailyTask) {
            this.selectedDailyTask = dailyTask;
            this.$refs.calendarModal.openModal();
            this.loadItems();
        },
        loadItems() {
            this.setLoading(true);
            DailyTask.index(this.serverParams)
            .then(response => {
                this.daily_tasks = response.data.data;
                this.totalRows = response.data.meta.total;
                this.updateParams({
                        currentPage: response.data.meta.current_page,
                        page: response.data.meta.current_page,
                        perPage: response.data.meta.per_page,
                    });
                if (Object.keys(this.selectedDailyTask).length !== 0) {
                    const updatedTask = this.daily_tasks.find(task => task.id === this.selectedDailyTask.id);
                    if (updatedTask) {
                        this.selectedDailyTask = updatedTask;
                    }
                }
            }).finally(() => {
                this.setLoading(false);
            });
        },
        
        resetPagination(){
            this.serverParams.page = 1;
            this.serverParams.currentPage = 1;
            this.paginationOptions = Object.assign({}, this.paginationOptions, {setCurrentPage: 1});
        },

        /* showAllColumns(){
            this.columns.forEach((c,i) => {
                if(c.hidden !== undefined){
                    this.columns[i].hidden = false;
                }
            })
        },
        toggleColumnVisibility(column){
            if(column.hidden){
                this.allColumnsShown = false;
            }
        } */

    }
}
</script>